import { saveAs } from 'file-saver';

export const downloadFile = (content, filename, mimeType = '') => {
  const blob = new Blob([content], { type: mimeType });
  saveAs(blob, filename);
};
